import React from 'react';
import Ratings from '@hpstellar/core/Ratings'
import Typography from '@hpstellar/core/Typography';

import withPageComponents from '../../../page/components/with-page-components';
import ProductSegmentBadge from '../../../product/components/product-segment-badge';
import ProductJsonLd from '../../../product/components/product-json-ld';
import './title-section.less'

const titleSection = ({ product }) => {
    return product ? (<div className={'pdp-title-section'}>
        <ProductJsonLd product={product} />
        <div className={'clearfix review-section'}>
            <Ratings
                className={'float-left'}
                score={product.rating}
                reviewsCount={product.numReviews}
                size='large'
                anchorLink />
            <ProductSegmentBadge
                product={product}
                className={'right'} />
        </div>
        <Typography className='pdp-title' variant='headingSubheader' tag={'h1'}>{product.name}</Typography>
    </div>) : null;
}

export default withPageComponents(titleSection, { components: ['product'] })
